import { useNavigate } from 'react-router-dom';
import { _ } from 'gridjs-react';
import { useSelector } from 'react-redux';

import { Integration } from 'lib/types';
import { selectCanManageIntegrations } from 'reducers/credentials/selectors'

import Button from 'components/Button/Button';
import Table from 'components/Table/Table';
import { Cell, Row } from 'gridjs';

function IntegrationList(props: IntegrationListProps) {
    const { integrations } = props;
    const navigate = useNavigate();

    const handleRegisterNewIntegrationClicked = () => {
        navigate('/integrations/create-integration');
    };

    const canManageIntegrations = useSelector(selectCanManageIntegrations);

    const columns = [
        { id: 'id', name: 'ID' },
        {
            id: 'name',
            name: 'Name',
            formatter: (cell: Cell, row: Row) =>
                _(
                    <a href="#"
                        onClick={(e) => {
                            e.preventDefault();
                            navigate(
                                `/integrations/${row.cells[0].data}/licenses`
                            )
                        }
                        }
                    >
                        {cell}
                    </a>
                ),
        },
        { id: 'issuedEntries', name: 'Issued Entries' },
        { id: 'licenseCount', name: 'License Count' },
        { id: 'uniqueSLCs', name: 'Unique SLCs' }
    ];

    if (canManageIntegrations) {
        columns.push({
            id: 'edit',
            name: 'Edit',
            formatter: (cell: Cell, row: Row) =>
                _(
                    <a
                        href="#"
                        onClick={(e) => {
                            e.preventDefault();
                            navigate(`/integrations/${row.cells[0].data}/edit`);
                        }}
                    >
                        Edit
                    </a>
                ),
        })
    }

    const data = integrations.map((integration) => ({
        ...integration,
        issuedEntries: integration.licenses?.length,
        // Sum the count attribute of each license, using 1 as a fallback if it is not set
        licenseCount: integration.licenses?.reduce(
            (sum, license) => sum + license.count ?? 1,
            0
        ),
        // Create a set from license SLCs, then count the set size to get number of unique SLCs
        uniqueSLCs: new Set(
            integration.licenses?.map((license) => license.softwareLicenseCode)
        ).size,
    }));

    return (
        <div>
            <Table
                columns={columns}
                data={data}
                pagination={{ enabled: true, limit: 10 }}
                search={{ enabled: true }}
            />

            {canManageIntegrations && <Button
                color="secondary"
                onClick={handleRegisterNewIntegrationClicked}
            >
                Register new integration
            </Button>}
        </div>
    );
}

type IntegrationListProps = {
    integrations: Integration[];
};

export default IntegrationList;
